var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "curriculumClasses" },
    [
      _vm.list.length > 0
        ? _c(
            "div",
            { staticClass: "curriculum-content" },
            _vm._l(_vm.list, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "list-item",
                  on: {
                    click: function ($event) {
                      return _vm.clickItem(item)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "list-item-top" }, [
                    _c(
                      "div",
                      { staticClass: "list-item-title" },
                      [
                        _c("div", { staticClass: "list-item-title-text" }, [
                          _vm._v(_vm._s(item.className)),
                        ]),
                        _c("van-icon", {
                          attrs: {
                            name: "arrow",
                            size: "0.2rem",
                            color: "#999",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "list-item-bottom" }, [
                    _c("div", { staticClass: "bottm-content" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("培训时间")]),
                      _c("div", { staticClass: "value" }, [
                        _vm._v(
                          " " +
                            _vm._s(item.trainingStartDate) +
                            " 至 " +
                            _vm._s(item.trainingEndDate) +
                            " "
                        ),
                      ]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "bottm-content maringTopContent" },
                      [
                        _c("div", { staticClass: "label" }, [_vm._v("班主任")]),
                        _c("div", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.teacher ? item.teacher : "暂无")),
                        ]),
                      ]
                    ),
                  ]),
                  _c("div", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.list.length - 1 != index,
                        expression: "(list.length - 1) != index",
                      },
                    ],
                    staticClass: "line-grey",
                  }),
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "arrange-nodata" }, [
            _c("div", { staticClass: "nodatacontent" }, [
              _c("img", {
                attrs: {
                  src: require("_teas/public/img/product/bootScreen/img-null.png"),
                  alt: "",
                  srcset: "",
                },
              }),
              _c("div", { staticClass: "text" }, [_vm._v("暂无课程")]),
            ]),
          ]),
      _c(
        "van-dialog",
        {
          staticClass: "curriculum-shu-dialog",
          attrs: {
            "show-confirm-button": false,
            "show-cancel-button": false,
            "close-on-click-overlay": true,
            "get-container": "#app",
          },
          model: {
            value: _vm.showDialog,
            callback: function ($$v) {
              _vm.showDialog = $$v
            },
            expression: "showDialog",
          },
        },
        [
          _c("dsf-icon", {
            staticClass: "dialog-closebutton",
            attrs: { name: "icon-close" },
            on: { click: _vm.clickDiaClose },
          }),
          _c("week-schedule", {
            attrs: {
              classInfor: _vm.classInfor,
              classId: _vm.classInfor.classId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }